import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space, Switch, Table } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
// import { formatDateTime } from "utils/formatter";
import { useSelector } from "react-redux";
import TableAntd from "components/elements/Table/Table";
const WorkingLocationTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
}) => {
  console.log("🚀 ~ onDelete:", onDelete)
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function formatDateTime(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543}  HH:mm น.`);
  }

  const columns = [
    {
      title: (
        <div className="text-table">{t("workin_location.label.name")}</div>
      ),
      dataIndex: "workInLocationName",
      key: "workInLocationName",
      sorter: {
        compare: (a, b) => null,
        multiple: 2,
      },
    },
    {
      title: (
        <div className="text-table">
          {t("workin_location.label.description")}
        </div>
      ),
      dataIndex: "description",
      key: "description",
      render: (_, record) => {
        const dataList = i18n.language === 'en' ? [
          record.locationCoordinates
            ? `Location: ${record.locationCoordinates}`
            : "",
          record.radius ? `Radius: ${record.radius} meters` : "",
          record.deviceName ? `Device Name: ${record.deviceName}` : "",
          record.deviceId ? `Device Id: ${record.deviceId}` : "",
          record.serialNumber ? `Serial Number: ${record.serialNumber}` : "",
        ] : [
          record.locationCoordinates
            ? `พิกัด: ${record.locationCoordinates}`
            : "",
          record.radius ? `รัศมี: ${record.radius} เมตร` : "",
          record.deviceName ? `ประเภทอุปกรณ์: ${record.deviceName}` : "",
          record.deviceId ? `รหัสอุปกรณ์: ${record.deviceId}` : "",
          record.serialNumber ? `หมายเลขประจำเครื่อง: ${record.serialNumber}` : "",
        ];
        const formatList = dataList
          .filter((d) => d !== "")
          .map((d, idx) => {
            if (idx === 0) return <>{d}</>;
            return (
              <>
                <br />
                {d}
              </>
            );
          });
        return formatList;
      },
    },
    {
      title: (
        <div className="text-table">
          {t("workin_location.label.last_modified")}
        </div>
      ),
      dataIndex: "lastModified",
      key: "lastModified",
      sorter: {
        compare: (a, b) => null,
        multiple: 2,
      },
      render: (_, record) => {
        const { lastModified = {} } = record;
        const name =
          i18n.language === "en" && lastModified.nameEn
            ? lastModified.nameEn
            : lastModified.name;
        if (record?.updateBy?.nameEn !== null) {
          return (
            <>
              {i18n.language === 'en' ? record?.updateBy?.nameEn + " " + record?.updateBy?.surNameEn : record?.updateBy?.name + " " + record?.updateBy?.surName}
              <br />
              {formatDateTime(record?.updateDate)}
            </>
          )
        } else {
          return (
            <>
              {i18n.language === 'en' ? record?.createBy?.nameEn + " " + record?.createBy?.surNameEn : record?.createBy?.name + " " + record?.createBy?.surName}
              <br />
              {formatDateTime(record?.createDate)}
            </>
          )
        }
      },
    },
    {
      title: (
        <div className="text-table">{t("workin_location.label.status")}</div>
      ),
      dataIndex: "statusFlag",
      key: "statusFlag",
      align: "center",
      render: (text, record) => (
        <Switch
          checked={text === "ACTIVE"}
          onChange={(checked) => onStatus(checked, record)}
        />
      ),
    },

    roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|WORK_IN_LOCATION",
      "DELETE_CONFIGURATION|ATTENDANCE_SETTING|WORK_IN_LOCATION"
    ) ? {
      title: (
        <div className="text-table">{t("workin_location.label.action")}</div>
      ),
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_CONFIGURATION|ATTENDANCE_SETTING|WORK_IN_LOCATION") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_CONFIGURATION|ATTENDANCE_SETTING|WORK_IN_LOCATION") && {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      scroll={{ x: true }}
    />
  );
};

export default WorkingLocationTable;
